import { parseISO } from "date-fns"
import { format } from "date-fns-tz"
import PropTypes from "prop-types"
import React from "react"

import Chips from "src/components/Chips"

import { titlecase } from "src/utils/string_helpers"

const spaceGroupChipText = (groupId, spaceGroups) => {
  switch (groupId) {
    case "all_assigned":
      return "Assigned"
    case "all_unassigned":
      return "Unassigned"
    case "groupless":
      return "Groupless Spaces"
    default:
      return (
        spaceGroups.find((sg) => sg.id.toString() === groupId)?.name || groupId
      )
  }
}

const FilterChips = ({ table, spaceGroups }) => {
  const { filters } = table

  const chips = []

  if (filters.searchTerm) {
    chips.push({
      key: "searchTerm",
      text: `Search: ${filters.searchTerm}`,
      onClick: () => table.clearFilter("searchTerm"),
    })
  }

  if (filters.statuses?.length > 0) {
    filters.statuses.forEach((status) => {
      chips.push({
        key: `status-${status}`,
        text: `Status: ${titlecase(status)}`,
        onClick: () =>
          table.setFilter(
            "statuses",
            filters.statuses.filter((s) => s !== status)
          ),
      })
    })
  }

  if (filters.inMarinaStartDate && filters.inMarinaEndDate) {
    const start = format(parseISO(filters.inMarinaStartDate), "MM/dd/yyyy")
    const end = format(parseISO(filters.inMarinaEndDate), "MM/dd/yyyy")
    chips.push({
      key: "inMarina",
      text: `In marina: ${start} – ${end}`,
      onClick: () =>
        table.setFilters({ inMarinaStartDate: null, inMarinaEndDate: null }),
    })
  }

  if (filters.spaceGroups?.length > 0) {
    filters.spaceGroups.forEach((groupId) => {
      chips.push({
        key: `spaceGroup-${groupId}`,
        text: spaceGroupChipText(groupId, spaceGroups),
        onClick: () =>
          table.setFilter(
            "spaceGroups",
            filters.spaceGroups.filter((g) => g !== groupId)
          ),
      })
    })
  }

  if (filters.nightsMin != null || filters.nightsMax != null) {
    const min = filters.nightsMin
    const max = filters.nightsMax
    const text =
      min != null && max != null && min === max
        ? `Exactly ${min} nights`
        : min != null && max != null
        ? `Between ${min} – ${max} nights`
        : min != null
        ? `At least ${min} nights`
        : `At most ${max} nights`
    chips.push({
      key: "nights",
      text,
      onClick: () => table.setFilters({ nightsMin: null, nightsMax: null }),
    })
  }

  const paymentStatusLabel = (id) => {
    switch (id) {
      case "awaiting_refund":
        return "Awaiting Refund"
      case "payment_declined":
        return "Payment Declined"
      case "missing_card":
        return "Missing Card"
      case "overdue_balance":
        return "Overdue Balance"
      default:
        return id
    }
  }

  if (filters.paymentStatuses?.length > 0) {
    filters.paymentStatuses.forEach((status) => {
      chips.push({
        key: `paymentStatus-${status}`,
        text: paymentStatusLabel(status),
        onClick: () =>
          table.setFilter(
            "paymentStatuses",
            filters.paymentStatuses.filter((s) => s !== status)
          ),
      })
    })
  }

  if (chips.length === 0) return null

  return (
    <div className="px-4 xl:px-0">
      <Chips onReset={() => table.clearAllFilters()}>
        {chips.map((chip) => (
          <Chips.Chip key={chip.key} text={chip.text} onClick={chip.onClick} />
        ))}
      </Chips>
    </div>
  )
}

FilterChips.propTypes = {
  table: PropTypes.object.isRequired,
  spaceGroups: PropTypes.array.isRequired,
}

export default FilterChips
